// Rated Orders — customer apology push, sent ONCE when support first moves a complaint to
// In Progress (not at rating time; changed 2026-10-14 at Amro's request). Gated by the
// settings/ratedOrders customerApologyPush switch only (test-customer allow-list retired
// 2026-10-14 when the feature went live). Written as a notifications/{id}
// doc like every other transactional push (sendNotification delivers it).
import { ORDER_COLLECTION } from '../../../../config/env';
import { firestore } from '../../../../helpers/Firebase';

export const APOLOGY_DEFAULTS = Object.freeze({
  en: {
    title: "We're sorry about your experience",
    body: 'Thank you for your feedback on order #{orderNumber}. Our support team is looking into it and will contact you shortly.',
  },
  ar: {
    title: 'نعتذر عن تجربتك',
    body: 'شكراً لملاحظاتك على الطلب رقم {orderNumber}. فريق الدعم يتابع الأمر وسيتواصل معك قريباً.',
  },
});

export function buildApologyNotification({ booking, bookingId, settings, fcmToken }) {
  const b = booking || {};
  const lang = b.locale === 'ae' ? 'ar' : 'en';
  const custom = String((settings && settings.apologyCopy && settings.apologyCopy[lang]) || '').trim();
  const body = (custom || APOLOGY_DEFAULTS[lang].body).replace(/\{orderNumber\}/g, String(b.orderNumber || ''));
  return {
    user: b.customer_id, to: fcmToken,
    title: APOLOGY_DEFAULTS[lang].title, body,
    page: 'OrderDetail', route: 'booking', routeParams: { bookingId },
    bookingId, read: false, ratedOrders: 'apology', created: Date.now(),
  };
}

/**
 * Send the apology if it is due. Never throws; returns { sent, reason }.
 * Due = switch on, not sent before, customer has a push token.
 */
export async function sendApologyIfDue({ booking }) {
  try {
    const bookingId = booking?.key || booking?.id || booking?.bookingId;
    if (!bookingId || !booking?.customer_id) return { sent: false, reason: 'noCustomer' };
    if (booking?.complaint?.apologySentAt) return { sent: false, reason: 'alreadySent' };
    const settings = (await firestore().collection('settings').doc('ratedOrders').get()).data() || {};
    if (settings.customerApologyPush !== true) return { sent: false, reason: 'off' };
    const user = (await firestore().collection('users').doc(booking.customer_id).get()).data() || {};
    if (!user.fcm_token) return { sent: false, reason: 'noToken' };
    // Claim the send in a transaction so two agents (or a stale screen) can never send it twice.
    const ref = firestore().collection(ORDER_COLLECTION).doc(bookingId);
    const at = Date.now();
    const claimed = await firestore().runTransaction(async (tx) => {
      const snap = await tx.get(ref);
      if (snap.data()?.complaint?.apologySentAt) return false;
      tx.update(ref, { 'complaint.apologySentAt': at });
      return true;
    });
    if (!claimed) return { sent: false, reason: 'alreadySent' };
    try {
      await firestore().collection('notifications').add(buildApologyNotification({ booking, bookingId, settings, fcmToken: user.fcm_token }));
    } catch (e) {
      await ref.update({ 'complaint.apologySentAt': firestore.FieldValue.delete() }).catch(() => null);
      throw e;
    }
    return { sent: true, reason: 'ok', at };
  } catch (e) {
    console.error('apology push failed', e);
    return { sent: false, reason: 'error' };
  }
}
